export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this a physical product?',
    answer: 'No. GOLF COACH PRO™ is 100% digital.',
  },
  {
    question: 'Is this for beginner coaches?',
    answer:
      "It's designed especially for experienced golf professionals who want to reduce preparation time.",
  },
  {
    question: 'Is it just golf theory?',
    answer:
      'No. The focus is ready-to-use sessions, drills, assessments, plans, templates, and coaching tools.',
  },
  {
    question: 'Does it include complete sessions?',
    answer:
      "Yes. You'll receive complete ready-to-coach sessions for different golf skills and objectives.",
  },
  {
    question: 'Can I adapt it to different golfers?',
    answer:
      'Yes. The resources include variations, progressions, regressions, and adaptable formats.',
  },
  {
    question: 'Does it include player practice plans?',
    answer:
      'Yes. Structured practice plans are included for different skills and available practice times.',
  },
  {
    question: 'How will I receive it?',
    answer: 'Immediately after payment by digital delivery.',
  },
  {
    question: 'Can I use it with juniors and group clinics?',
    answer:
      'Yes. The Junior & Group Golf Coaching Vault™ bonus includes junior sessions, group games, stations, challenges, clinics, and mixed-ability adaptations.',
  },
  {
    question: 'Can I print the planners and trackers for my lessons?',
    answer:
      'Yes. The lesson planners, coaching notes, goal sheets, practice prescriptions, and progress trackers are made to be printed or personalized and shared digitally with your players.',
  },
  {
    question: 'How long do I keep access, and what if I need help?',
    answer:
      'Your access does not expire — download everything and keep using it season after season. If you have any question about your delivery or the resources, contact support at kitonline27@gmail.com.',
  },
]
